<template>
    <div class="publicAudio">
        <div class="paper-aution" style="padding-left:10px;color:#387dfe;cursor: pointer;" @click.stop="startAudio">
        <i :class="isAudio ? 'icon-al-pausecircle' : 'icon-al-playcircle'" ></i>
    </div>
        <audio ref="audio" class="aud" @ended="onAudioEnded">
        <source :src="audioSrc" />
    </audio>
    </div>
</template>
<script>
export default {
    props:{
       audioSrc: [String, Number]
  },
    data() {
        return {
           isAudio:false 
        }
    },
    created() {
    },
    methods: {
        // 点击播放或暂停
        startAudio(){
      this.isAudio = !this.isAudio
      if(this.isAudio){
        this.$refs.audio.play();
      }else{
        this.$refs.audio.pause();
      }
        },
        // 播放结束
        onAudioEnded(){
            this.isAudio  = false
        }
    },
}
</script>
<style lang="scss" scoped>

</style>